import React from "react";
import "./navbar.scss";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Smartphone, UserRound } from "lucide-react";

const Navbar = () => {
  const userData = useSelector((state) => state.userData.user);
  const isAuthenticated = Boolean(userData?.user?._id);

  return (
    <div className="navbar-wrapper">
      <div className="navbar-shell">
        <nav className="navbar navbar-expand-xl teleport-navbar" aria-label="Main navigation">
          <div className="container-fluid teleport-navbar__inner">
            <Link className="navbar-brand" to="/">
              <img
                src="/images/Android.png"
                alt="Teleport Now Logo"
                className="header-logo"
                width="48"
                height="48"
              />
              <span>Teleport Now</span>
            </Link>

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <div className="teleport-service-links">
                <Link to="/flights">Flights</Link>
                <Link to="/esim">eSIMs</Link>
                <Link to="/things-to-do">Things To Do</Link>
                <Link to="/airport-lounges">Airport Lounge</Link>
              </div>
              <div className="teleport-nav-actions">
                {isAuthenticated ? (
                  <div className="account-links">
                    <Link to="/my-profile" className="profile-link">
                      <UserRound size={16} />
                      My Profile
                    </Link>
                  </div>
                ) : (
                  <Link to="/login" className="profile-link">
                    <UserRound size={16} />
                    Sign in
                  </Link>
                )}
                <Link to="/download" className="download-app-btn">
                  <Smartphone size={16} />
                  <span>Download App</span>
                </Link>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
